import { render, staticRenderFns } from "./EnvironmentClosed.vue?vue&type=template&id=b71d975a&scoped=true&"
import script from "./EnvironmentClosed.vue?vue&type=script&lang=js&"
export * from "./EnvironmentClosed.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentClosed.vue?vue&type=style&index=0&id=b71d975a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71d975a",
  null
  
)

export default component.exports